import _defineProperty from "/build/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useRef, useEffect, useContext } from 'react';
import { analyticsReady, dispatchImmediateAnalyticsEvent, dispatchAnalyticsEvent, setJLData, ANALYTICS_JLDATA_UPDATED, addCustomSchema } from '@JohnLewisPartnership/jl-analytics';
import { createDebugger } from '../../utils/debug';
import { jsx as _jsx } from "react/jsx-runtime";
var debug = createDebugger('analytics');
export var Context = /*#__PURE__*/React.createContext();
export { addCustomSchema };
export var useAnalytics = function useAnalytics(eventName) {
  var defaultEventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!eventName) {
    throw new Error("Expected useAnalytics(\"event.name\") received event name: \"".concat(eventName, "\""));
  }

  return function () {
    var eventData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    dispatchAnalyticsEvent(eventName, _objectSpread(_objectSpread({}, defaultEventData), eventData));
  };
};
export var useImmediateAnalytics = function useImmediateAnalytics(eventName) {
  var defaultEventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!eventName) {
    throw new Error("Expected useAnalytics(\"event.name\") received event name: \"".concat(eventName, "\""));
  }

  return function () {
    var eventData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    dispatchImmediateAnalyticsEvent(eventName, _objectSpread(_objectSpread({}, defaultEventData), eventData));
  };
};
export var usePageLoadReady = function usePageLoadReady() {
  var _useContext = useContext(Context),
      lastUpdatedTimestamp = _useContext[0];

  var firedRef = useRef(false);
  useEffect(function () {
    var readyInterval = setInterval(function () {
      if (analyticsReady() && lastUpdatedTimestamp && !firedRef.current) {
        firedRef.current = true;
        clearInterval(readyInterval);
        dispatchImmediateAnalyticsEvent('pageload');
      }
    }, 100);
  }, [lastUpdatedTimestamp]);
};
export var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      lastUpdatedTimestamp = _useState[0],
      setTimestamp = _useState[1];

  var updateTimestamp = function updateTimestamp() {
    return setTimestamp(Number(new Date()));
  };

  return /*#__PURE__*/_jsx(Context.Provider, {
    value: [lastUpdatedTimestamp, updateTimestamp],
    children: children
  });
};
export var Analytics = function Analytics(payload) {
  var _useContext2 = useContext(Context),
      updateTimestamp = _useContext2[1];

  useEffect(function () {
    setJLData(payload);
    updateTimestamp();
    debug("dispatching event \"".concat(ANALYTICS_JLDATA_UPDATED, "\""));
    document.body.dispatchEvent(new CustomEvent(ANALYTICS_JLDATA_UPDATED)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);
  return null;
};